import { createTheme } from "@mui/material/styles";

// ── Palette principale ────────────────────────────────────────────────────────
export const P = {
  navy:   "#1e3a5f",
  navyL:  "#243b5c",
  red:    "#c0392b",
  redL:   "#e74c3c",
  green:  "#27ae60",
  amber:  "#d97706",
  teal:   "#0d9488",
  indigo: "#6366f1",
  white:  "#ffffff",
  slate: {
    50:  "#f8fafc",
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5e1",
    400: "#94a3b8",
    500: "#64748b",
    600: "#475569",
    700: "#334155",
    800: "#1e293b",
  },
};

/** Couleur selon le pourcentage (vert ≥70, orange ≥50, rouge <50) */
export const pctColor = (pct) =>
  pct >= 70 ? P.green : pct >= 50 ? P.amber : P.red;

/** Calcule le pourcentage d'une tentative (serveur ou local) */
export const getPct = (attempt) => {
  if (attempt.percentage != null) return Math.round(attempt.percentage);
  if (attempt.max_score)          return Math.round((attempt.score / attempt.max_score) * 100);
  return 0;
};

// ── Compatibilité arrière ─────────────────────────────────────────────────────
// Ces exports permettent aux anciens fichiers de continuer à fonctionner
// sans modification après la migration vers P.

/**
 * Alias C — compatible avec l'ancienne convention C.indigo[500], C.teal[600], etc.
 * L'ancien thème utilisait des objets de teintes ; on les reconstruit ici.
 */
export const C = {
  ...P,
  // Teintes indigo
  indigo: { 50:"#eef2ff", 100:"#e0e7ff", 200:"#c7d2fe", 300:"#a5b4fc", 400:"#818cf8", 500:"#6366f1", 600:"#4f46e5", 700:"#4338ca", 800:"#3730a3", 900:"#312e81" },
  // Teintes teal
  teal:   { 50:"#f0fdfa", 100:"#ccfbf1", 200:"#99f6e4", 300:"#5eead4", 400:"#2dd4bf", 500:"#14b8a6", 600:"#0d9488", 700:"#0f766e", 800:"#115e59" },
  // Teintes green
  green:  { 50:"#f0fdf4", 100:"#dcfce7", 200:"#bbf7d0", 300:"#86efac", 400:"#4ade80", 500:"#22c55e", 600:"#16a34a", 700:"#15803d", 800:"#166534" },
  // Teintes red
  red:    { 50:"#fef2f2", 100:"#fee2e2", 200:"#fecaca", 300:"#fca5a5", 400:"#f87171", 500:"#ef4444", 600:"#dc2626", 700:"#b91c1c", 800:"#991b1b" },
  // Teintes amber
  amber:  { 50:"#fffbeb", 100:"#fef3c7", 200:"#fde68a", 300:"#fcd34d", 400:"#fbbf24", 500:"#f59e0b", 600:"#d97706", 700:"#b45309", 800:"#92400e" },
  // Teintes slate (déjà dans P mais P.slate est un objet)
  slate:  P.slate,
  // Teintes supplémentaires utilisées dans Home.jsx, Login.jsx etc.
  purple: { 50:"#faf5ff", 100:"#f3e8ff", 400:"#c084fc", 500:"#a855f7", 600:"#9333ea", 700:"#7e22ce" },
  blue:   { 50:"#eff6ff", 100:"#dbeafe", 400:"#60a5fa", 500:"#3b82f6", 600:"#2563eb", 700:"#1d4ed8" },
  pink:   { 50:"#fdf2f8", 100:"#fce7f3", 400:"#f472b6", 500:"#ec4899", 600:"#db2777" },
  orange: { 50:"#fff7ed", 100:"#ffedd5", 400:"#fb923c", 500:"#f97316", 600:"#ea580c" },
};

/** Gradient indigo utilisé dans App.jsx, Login, Register, AdminResults... */
export const indigoGradient = `linear-gradient(135deg, ${P.indigo} 0%, #7c3aed 100%)`;

/** Gradient hero pour Home.jsx */
export const heroGradient = `linear-gradient(135deg, ${P.navy} 0%, ${P.indigo} 100%)`;

/** Style CSS-in-JS pour texte en dégradé */
export const gradientText = {
  background: indigoGradient,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

/** Thème MUI — doit être déclaré après P et indigoGradient */
export const theme = createTheme({
  palette: {
    primary:    { main: P.indigo },
    secondary:  { main: P.teal },
    background: { default: P.slate[50], paper: "#ffffff" },
  },
  typography: {
    fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600, borderRadius: 8 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
  },
});